import axios from 'axios'
import { useCallback, useEffect, useMemo, useState } from 'react'
import { defaultSiteSettings, SiteSettingsContext, type SiteSettings } from './siteSettingsStore'

export const SiteSettingsProvider = ({ children }: { children: React.ReactNode }) => {
  const [settings, setSettings] = useState(defaultSiteSettings)
  const [loading, setLoading] = useState(true)

  const refreshSettings = useCallback(async () => {
    try {
      const { data } = await axios.get<SiteSettings>('/api/site-settings')
      setSettings({
        heroBackgroundUrl: data.heroBackgroundUrl || null,
        pageBackgroundUrl: data.pageBackgroundUrl || null,
        birthdayReminderDays: Number.isInteger(data.birthdayReminderDays) ? data.birthdayReminderDays : 1,
      })
    } catch {
      setSettings(defaultSiteSettings)
    } finally {
      setLoading(false)
    }
  }, [])

  useEffect(() => {
    void refreshSettings()
  }, [refreshSettings])

  const value = useMemo(
    () => ({ settings, loading, refreshSettings }),
    [settings, loading, refreshSettings],
  )

  return <SiteSettingsContext.Provider value={value}>{children}</SiteSettingsContext.Provider>
}
